<template>
    <div class="loginSetting">
        <el-row>
            <el-collapse v-model="activeName" @change="handleChange" accordion>
                <el-collapse-item :name="rosterList.whiteList.name">
                    <template slot="title">
                        <div class="userInfoTitle"></div>
                        <div class="collapseTitle">
                            <span>{{ $t('userInfo.IP_WHITE_LIST') }}</span>
                        </div>
                        <div v-if="rosterList.whiteList.showFlag" @click="stopProp" style="position: absolute;right: 40px">
                            <span style="vertical-align:middle;">{{ $t('userInfo.TOGETHER') }}</span>
                            <span style="vertical-align:middle;">{{ ipList.length }}</span>
                            <span style="vertical-align:middle;">{{ $t('userInfo.STRIP') }}</span>
                            <el-dropdown trigger="click" class="dropDownDeep">
                                <td-button class="iconButton" type="text" size="small"><img :src="addImg" style="margin-top: 5px"/></td-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="addIpWhite()">IP</el-dropdown-item>
                                    <el-dropdown-item @click.native="addDoubleIpWhite()">{{ $t('userInfo.DOUBLE_IP') }}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                    <div class="whiteListBackground" style="width: 100%">
                        <div v-for="(ip, index) in ipList" :key="index" style="padding-top:10px;">
                            <el-row>
                                <el-col :span="21" style="padding-left:20px;">
                                    {{ ip }}
                                </el-col>
                                <el-col :span="3" style="padding-right:20px;">
                                    <td-button class="wordButton" size="small" @click="deleteIpWhite(ip)">{{ $t('common.DELETE') }}</td-button>
                                </el-col>
                            </el-row>
                            <div class="splitBorder"></div>
                        </div>
                        <div v-for="(item, index) in formIpWhiteList.ipList" :key="'formIpWhiteList' + index">
                            <el-form :model="formIpWhiteList" :ref="'formIpWhiteList' + index">
                                <el-row>
                                    <el-col :span="5" style="padding-left:20px;" class="inputDeep">
                                        <el-form-item :prop="'ipList.' + index + '.ipOne'" :rules="rules.ipOne">
                                            <td-input v-focus size="mini" style="width: 100%;" placeholder="" v-model="item.ipOne" clearable></td-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="1" style="padding-left: 20px;padding-top: 20px;" v-if="item.showIpSegmentFlag">
                                        <span>{{ $t('common.UNTIL') }}</span>
                                    </el-col>
                                    <el-col :span="5" style="padding-left:20px;" v-if="item.showIpSegmentFlag">
                                        <el-form-item :prop="'ipList.' + index + '.ipTwo'" :rules="rules.ipTwo">
                                            <td-input v-focus size="mini" style="width: 100%;" placeholder="" v-model="item.ipTwo" clearable></td-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="item.showIpSegmentFlag ? 8 : 14" style="padding-left:20px;">
                                        <el-form-item prop="addIp">
                                            <td-button type="primary" @click="addIPSegment(item)" size="small">{{ item.ipBtnText }}</td-button>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2" style="margin-left: auto">
                                        <el-form-item prop="confirmIp">
                                            <td-button class="wordButton" @click="confirmIpWhite(item, index)" size="small">{{ $t('common.CONFIRM') }}</td-button>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2" style="margin-left: auto">
                                        <el-form-item prop="cancelIp">
                                            <td-button class="wordButton" @click="cancelIpWhite(index)" size="small">{{ $t('common.CANCEL') }}</td-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="splitBorder"></div>
                        </div>
                        <div style="padding-top:10px;">
                            <span class="whiteListTip">{{ $t('userInfo.ADD_BY_CLICK_BUTTON') }}</span>
                        </div>
                    </div>
                </el-collapse-item>
                <el-collapse-item :name="rosterList.MACList.name">
                    <template slot="title">
                        <div class="userInfoTitle"></div>
                        <div class="collapseTitle">
                            <span>{{ $t('userInfo.MAC_WHITE_LIST') }}</span>
                        </div>
                        <div v-if="rosterList.MACList.showFlag" @click="stopProp" style="position: absolute;right: 40px">
                            <span style="vertical-align:middle">{{ $t('userInfo.TOGETHER') }}</span>
                            <span style="vertical-align:middle">{{ macList.length }}</span>
                            <span style="vertical-align:middle">{{ $t('userInfo.STRIP') }}</span>
                            <td-button class="iconButton" type="text" size="small" @click="addMacWhite()"><img :src="addImg" style="margin-top: 5px"/></td-button>
                        </div>
                    </template>
                    <div class="whiteListBackground" style="width: 100%;">
                        <div v-for="(mac, index) in macList" :key="index" style="padding-top:10px;">
                            <el-row>
                                <el-col :span="21" style="padding-left:20px;">
                                    {{ mac }}
                                </el-col>
                                <el-col :span="3" style="padding-right:20px;">
                                    <td-button class="wordButton" size="small" @click="deleteMacWhite(mac)">{{ $t('common.DELETE') }}</td-button>
                                </el-col>
                            </el-row>
                            <div class="splitBorder"></div>
                        </div>
                        <div v-for="(item, index) in formMacWhiteList.macList" :key="'formMacWhiteList' + index">
                            <el-form :model="formMacWhiteList" :ref="'formMacWhiteList' + index">
                                <el-row>
                                    <el-col :span="19" style="padding-left:20px;" class="inputDeep">
                                        <el-form-item :prop="'macList.' + index + '.mac'" :rules="rules.mac">
                                            <td-input v-focus size="mini" style="width: 35%;" placeholder="" v-model="item.mac" clearable></td-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2" style="margin-left: auto">
                                        <el-form-item>
                                            <td-button class="wordButton" @click="confirmMacWhite(item.mac, index)" size="small">{{ $t('common.CONFIRM') }}</td-button>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2" style="margin-left: auto">
                                        <el-form-item>
                                            <td-button class="wordButton" @click="cancelMacWhite(index)" size="small">{{ $t('common.CANCEL') }}</td-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="splitBorder"></div>
                        </div>
                        <div style="padding-top:10px;">
                            <span class="whiteListTip">{{ $t('userInfo.ADD_BY_CLICK_BUTTON') }}</span>
                        </div>
                    </div>
                </el-collapse-item>

                <el-collapse-item :name="rosterList.timeList.name">
                    <template slot="title">
                        <div class="userInfoTitle"></div>
                        <div style="margin: 0px 50% 0px 8px;font-size: 16px">
                            <span>{{ $t('userInfo.TIME_WHITE_LIST') }}</span>
                        </div>
                        <div v-if="rosterList.timeList.showFlag" @click="stopProp" style="position: absolute;right: 40px">
                            <span style="vertical-align:middle">{{ $t('userInfo.TOGETHER') }}</span>
                            <span style="vertical-align:middle">{{ timeList.length }}</span>
                            <span style="vertical-align:middle">{{ $t('userInfo.STRIP') }}</span>
                            <td-button class="iconButton" type="text" size="small" @click="addTimeWhite()"><img :src="addImg" style="margin-top: 5px"/></td-button>
                        </div>
                    </template>
                    <div class="whiteListBackground" style="width: 100%">
                        <div v-for="(time, index) in timeList" :key="index" style="padding-top:10px;">
                            <el-row>
                                <el-col :span="21" style="padding-left:20px;">
                                    {{ time }}
                                </el-col>
                                <el-col :span="3" style="padding-right:20px;">
                                    <td-button class="wordButton" size="small" @click="deleteTimeWhite(time)">{{ $t('common.DELETE') }}</td-button>
                                </el-col>
                            </el-row>
                            <div class="splitBorder"></div>
                        </div>
                        <div v-for="(item, index) in formTimeWhiteList.timeList" :key="'formTimeWhiteList' + index">
                            <el-form :model="formTimeWhiteList" :ref="'formTimeWhiteList' + index">
                                <el-row>
                                    <el-col :span="19" style="padding-left:20px;" class="inputDeep">
                                        <el-form-item :prop="'timeList.' + index + '.time'" :rules="rules.time">
                                            <el-time-picker
                                                is-range
                                                v-model="item.time"
                                                range-separator="至"
                                                start-placeholder="开始时间"
                                                end-placeholder="结束时间"
                                                placeholder="选择时间范围"
                                                value-format="HH:mm:ss"
                                                size="small"
                                            >
                                            </el-time-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2" style="margin-left: auto">
                                        <el-form-item>
                                            <td-button class="wordButton" @click="confirmTimeWhite(item.time, index)" size="small">{{ $t('common.CONFIRM') }}</td-button>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2" style="margin-left: auto">
                                        <el-form-item>
                                            <td-button class="wordButton" @click="cancelTimeWhite(index)" size="small">{{ $t('common.CANCEL') }}</td-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="splitBorder"></div>
                        </div>
                        <div style="padding-top:10px;">
                            <span class="whiteListTip">{{ $t('userInfo.ADD_BY_CLICK_BUTTON') }}</span>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <div style="text-align: center;">
                <td-button type="primary" @click="btnSaveWhiteList()" :loading="loading">
                    {{ $t('common.SAVE') }}
                </td-button>
                <td-button type="button" @click="userDialogClose()">
                    {{ $t('common.CANCEL') }}
                </td-button>
            </div>
        </el-row>
    </div>
</template>
<script>
export default {
    //默认显示光标
    directives: {
        // 注册一个局部的自定义指令 v-focus
        focus: {
            // 指令的定义
            inserted: function(el) {
                // 聚焦元素
                el.querySelector('input').focus();
            }
        }
    },
    props: {
        isAddData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        ipList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        macList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        timeList: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    components: {},
    computed: {
        addImg: function() {
            return 'auth/' + window.vue.$store.state.skin + '/img/add.png';
        },
        fontsize() {
            return window.vue.$store.state.fontSize;
        }
    },
    watch: {
        //观察字体大小的变化
        fontsize: {
            immediate: true,
            handler(newVal, oldVal) {
                this.modifyDialogWidth = 860 + (Number(newVal) == 14 ? 0 : Number(newVal));
            },
            deep: true //对象内部属性的监听，关键。
        }
    },
    created() {},
    // 定义变量
    data() {
        let validateMac = (rule, value, callback) => {
            if (value === '') {
                callback(this.$t('userInfo.INPUT_MAC_PHONE'));
            }
            //校验是mac地址或者是32位英数字组合
            let macReg = new RegExp(this.$regex.MAC_RULE_COLON);
            let numRreg = new RegExp('^([a-zA-Z0-9_]){32}$');
            if (macReg.test(value) || numRreg.test(value)) {
                callback();
            } else {
                callback(this.$t('userInfo.ERROR_WHITE_FORMATE'));
            }
            if (this.macList.indexOf(value) > -1) {
                callback(this.$t('error.ERROR_MAC_REPEAT'));
            } else {
                callback();
            }
        };
        let validateTime = (rule, value, callback) => {
            if (value === '') {
                callback(this.$t('userInfo.INPUT_TIME_LIST'));
            } else {
                callback();
            }
        };
        let validateIpWhite = (rule, value, callback) => {
            if (value === '') {
                callback(this.$t('error.ERROR_IP_NULL'));
            }
            let ipReg = new RegExp(this.$regex.IP_RULE);
            if (!ipReg.test(value)) {
                callback(this.$t('error.ERROR_IP_FORMAT'));
            }
            let ipOne = '';
            this.formIpWhiteList.ipList.forEach(data => {
                if (data.ipTwo === value) {
                    ipOne = data.ipOne;
                }
            });
            let ipArrayOne = ipOne.split('.');
            let ipArrayTwo = value.split('.');
            if (ipArrayOne[0] !== ipArrayTwo[0] || ipArrayOne[1] !== ipArrayTwo[1] || ipArrayOne[2] !== ipArrayTwo[2]) {
                callback(this.$t('userInfo.INPUT_IP_LIST'));
            }
            if (Number(ipArrayOne[3]) >= Number(ipArrayTwo[3])) {
                callback(this.$t('userInfo.INPUT_IP_NUM'));
            } else {
                callback();
            }
        };
        return {
            ipArrayOne: [],
            ipArrayTwo: [],
            //转为ip段按钮内容
            ipBtnText: this.$t('userInfo.TO_DOUBLE_IP'),
            rosterList: {
                whiteList: {
                    name: 'whiteList',
                    showFlag: true
                },
                MACList: {
                    name: 'MACList',
                    showFlag: false
                },
                timeList: {
                    name: 'timeList',
                    showFlag: false
                }
            },
            activeName: 'whiteList',
            formIpWhiteList: {
                ipList: []
            },
            formMacWhiteList: {
                macList: []
            },
            formTimeWhiteList: {
                timeList: []
            },
            rules: {
                ipOne: [{ required: true, message: this.$t('error.ERROR_IP_NULL'), trigger: 'blur' }, { pattern: this.$regex.IP_RULE, message: this.$t('error.ERROR_IP_FORMAT') }],
                ipTwo: [{ required: true, message: this.$t('error.ERROR_IP_NULL'), trigger: 'blur' }, { validator: validateIpWhite, trigger: ['blur', 'change'] }],
                mac: [{ required: true, message: this.$t('userInfo.INPUT_MAC_PHONE'), trigger: 'blur' }, { validator: validateMac, trigger: ['blur', 'change'] }],
                time: [{ required: true, message: this.$t('userInfo.INPUT_TIME_LIST'), trigger: 'blur' }, { validator: validateTime, trigger: ['blur', 'change'] }]
            },
            showFlag: false
        };
    },
    // 定义并实现方法体
    methods: {
        //转为ip段
        addIPSegment(item) {
            if (item.ipBtnText === this.$t('userInfo.TO_DOUBLE_IP')) {
                //改变按钮名称
                item.ipBtnText = this.$t('userInfo.TO_IP');
                //ip输入框是否显示
                item.showIpSegmentFlag = true;
            } else {
                //改变按钮名称
                item.ipBtnText = this.$t('userInfo.TO_DOUBLE_IP');
                //ip输入框是否显示
                item.showIpSegmentFlag = false;
            }
        },
        //监听点击事件，阻止冒泡
        stopProp(val) {
            val.stopPropagation();
        },
        handleChange() {
            let whiteShowFlag = false;
            let MACShowFlag = false;
            let timeShowFlag = false;
            if (this.rosterList.whiteList.name === this.activeName) {
                whiteShowFlag = true;
            } else if (this.rosterList.MACList.name === this.activeName) {
                MACShowFlag = true;
            } else if (this.rosterList.timeList.name === this.activeName) {
                timeShowFlag = true;
            }

            this.rosterList.whiteList.showFlag = whiteShowFlag;
            this.rosterList.MACList.showFlag = MACShowFlag;
            this.rosterList.timeList.showFlag = timeShowFlag;
        },
        //展示
        //添加ip
        addIpWhite() {
            let info = {
                ipOne: '',
                ipTwo: '',
                ipBtnText: this.$t('userInfo.TO_DOUBLE_IP'),
                //是否展示ip段
                showIpSegmentFlag: false
            };
            this.formIpWhiteList.ipList.push(info);
        },
        //添加ip段
        addDoubleIpWhite() {
            let info = {
                ipOne: '',
                ipTwo: '',
                ipBtnText: this.$t('userInfo.TO_IP'),
                //是否展示ip段
                showIpSegmentFlag: true
            };
            this.formIpWhiteList.ipList.push(info);
        },
        //删除ip
        deleteIpWhite(ip) {
            let index = this.ipList.indexOf(ip);
            if (index > -1) {
                this.ipList.splice(index, 1);
            }
        },
        //ip输入框确认
        confirmIpWhite(item, index) {
            this.$refs['formIpWhiteList' + index][0].validate(valid => {
                if (valid) {
                    let ipMsg = '';
                    if (item.ipBtnText === this.$t('userInfo.TO_DOUBLE_IP') || item.ipTwo === undefined || item.ipTwo === '') {
                        ipMsg = item.ipOne;
                    } else {
                        ipMsg = item.ipOne + ' ' + this.$t('common.UNTIL') + ' ' + item.ipTwo;
                    }
                    this.ipList.push(ipMsg);
                    this.cancelIpWhite(index);
                }
            });
        },
        //ip输入框取消
        cancelIpWhite(index) {
            this.formIpWhiteList.ipList.splice(index, 1);
        },
        //添加mac
        addMacWhite() {
            let info = {
                mac: ''
            };
            this.formMacWhiteList.macList.push(info);
        },
        //删除Mac
        deleteMacWhite(mac) {
            let index = this.macList.indexOf(mac);
            if (index > -1) {
                this.macList.splice(index, 1);
            }
        },
        //Mac输入框确认
        confirmMacWhite(mac, index) {
            this.$refs['formMacWhiteList' + index][0].validate(valid => {
                if (valid) {
                    if (this.macList.indexOf(mac) > -1) {
                        this.$message({ showClose: true, message: this.$t('error.ERROR_MAC_REPEAT'), type: 'warning' });
                        return;
                    }
                    this.macList.push(mac);
                    this.cancelMacWhite(index);
                }
            });
        },
        //Mac输入框取消
        cancelMacWhite(index) {
            this.formMacWhiteList.macList.splice(index, 1);
        },
        //添加time
        addTimeWhite() {
            let info = {
                time: ''
            };
            this.formTimeWhiteList.timeList.push(info);
        },
        //删除Time
        deleteTimeWhite(time) {
            let index = this.timeList.indexOf(time);
            if (index > -1) {
                this.timeList.splice(index, 1);
            }
        },
        //Time输入框确认
        confirmTimeWhite(time, index) {
            this.$refs['formTimeWhiteList' + index][0].validate(valid => {
                if (valid) {
                    let timeMsg = '';
                    timeMsg = time[0] + this.$t('common.UNTIL') + time[1];
                    this.timeList.push(timeMsg);
                    this.cancelTimeWhite(index);
                }
            });
        },
        //Time输入框取消
        cancelTimeWhite(index) {
            this.formTimeWhiteList.timeList.splice(index, 1);
        },
        btnSaveWhiteList() {
            let ipResult = true;
            let macResult = true;
            let timeResult = true;
            for (let index = 0; index < this.formIpWhiteList.ipList.length; index++) {
                this.$refs['formIpWhiteList' + index][0].validate(valid => {
                    if (!valid) {
                        ipResult = false;
                    }
                });
            }
            for (let index = 0; index < this.formMacWhiteList.macList.length; index++) {
                this.$refs['formMacWhiteList' + index][0].validate(valid => {
                    if (!valid) {
                        macResult = false;
                    }
                });
            }
            for (let index = 0; index < this.formTimeWhiteList.timeList.length; index++) {
                this.$refs['formTimeWhiteList' + index][0].validate(valid => {
                    if (!valid) {
                        timeResult = false;
                    }
                });
            }
            if (ipResult && macResult && timeResult) {
                this.$emit('whiteListSave', this.ipList, this.macList, this.timeList, this.formIpWhiteList, this.formMacWhiteList, this.formTimeWhiteList);
            }
        },
        userDialogClose() {
            this.$emit('whiteListClose');
        },
        getFormValid() {
            let formValid = false;
            let ipResult = true;
            let macResult = true;
            let timeResult = true;
            for (let index = 0; index < this.formIpWhiteList.ipList.length; index++) {
                this.$refs['formIpWhiteList' + index][0].validate(valid => {
                    if (!valid) {
                        ipResult = false;
                    }
                });
            }
            for (let index = 0; index < this.formMacWhiteList.macList.length; index++) {
                this.$refs['formMacWhiteList' + index][0].validate(valid => {
                    if (!valid) {
                        macResult = false;
                    }
                });
            }
            for (let index = 0; index < this.formTimeWhiteList.timeList.length; index++) {
                this.$refs['formTimeWhiteList' + index][0].validate(valid => {
                    if (!valid) {
                        timeResult = false;
                    }
                });
            }
            if (ipResult && macResult && timeResult) {
                formValid = true;
            }

            return formValid;
        }
    }
};
</script>
<style scoped>
.inputDeep >>> .el-input__inner {
    font-size: 14px;
}
.inputDeep >>> .el-collapse-item__arrow {
    margin: 20px 50px 0 auto;
}
.el-dropdown-menu {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0;
    margin: 0;
    background-color: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    align-items: center;
    justify-content: center;
}
.el-dropdown-menu__item {
    justify-content: center;
    padding: 0 30px;
}
.el-form {
    padding-top: 5px;
    margin-bottom: 0px;
}
.whitIpStyle {
    padding-left: 20px;
}
.collapseTitle {
    margin: 0px 50% 0px 8px;
    font-size: 16px;
}
.loginSetting {
    padding-left: 20px;
    padding-right: 20px;
}
/deep/ .el-button--small {
    font-size: 14px;
}
/deep/ .el-collapse-item {
    font-size: 14px;
}
/deep/ .el-collapse-item__header {
    font-size: 14px;
}
/deep/ .el-collapse-item__content {
    font-size: 14px;
}
.iconButton {
    margin: 0px 0px 0px 15px;
    padding-top: 5px;
    vertical-align: middle;
}
</style>
